import { useContext, useEffect } from "react";
import {
  VisitDetailsField,
  VisitDetailsFormSchemaState,
} from "@/pages/requests/components/visit-details-form/types";
import { logger, normalizeDropdownOptionsData } from "@/utils";
import { AuthContext } from "@/guards/auth/auth-context";
import { useRequestState } from "@/hooks";
import { requestPurposesList } from "@/services/api";

export const usePurposeList = () => {
  const { account } = useContext(AuthContext);

  const { data, error, setError, isLoading, setSuccess } =
    useRequestState<VisitDetailsFormSchemaState>();

  useEffect(() => {
    const controller = new AbortController();

    requestPurposesList(
      { email: account?.username ?? "" },
      { signal: controller.signal },
    )
      .then(response => {
        setSuccess({
          [VisitDetailsField.Purpose]: normalizeDropdownOptionsData(
            response,
            "PurposeEn",
          ),
        });
      })
      .catch(error => {
        setError(error.message);

        logger.error(error);
      });
  }, [account, setError, setSuccess]);

  return {
    isLoading,
    purpose: data || { [VisitDetailsField.Purpose]: [] },
    error,
  };
};
